import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap";

function useFonts() {
  useEffect(() => {
    if (document.querySelector('link[href*="Instrument+Serif"]')) return;
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = FONTS_URL;
    document.head.appendChild(l);
  }, []);
}

const T = {
  g700: "#155c36", g600: "#1b7a47", g500: "#1e9254", g400: "#28b566",
  g200: "#a7d9bc", g100: "#d6f0e3", g50: "#eef8f3",
  n900: "#0f1117", n800: "#1c2130", n700: "#2d3549", n600: "#4a5268",
  n400: "#8a93a8", n300: "#b0b8cc", n200: "#d1d5e0", n150: "#e4e7ef",
  n100: "#eef0f5", n50: "#f7f8fa", white: "#ffffff",
  amber: "#d97706", amberBg: "#fffbeb", amberBorder: "#fde68a",
  rose: "#e11d48", roseBg: "#fff1f2", roseBorder: "#fecdd3",
  serif: "'Instrument Serif', Georgia, serif",
  sans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
};

const Icon = ({ name, size = 20, color = "currentColor", strokeWidth = 1.6 }) => {
  const paths = {
    ArrowLeft:    <><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></>,
    ArrowRight:   <><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></>,
    Search:       <><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></>,
    MapPin:       <><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></>,
    Star:         <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>,
    CheckCircle:  <><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></>,
    ShieldCheck:  <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></>,
    BadgeCheck:   <><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></>,
    Calendar:     <><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></>,
    Clock:        <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
    Wallet:       <><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/><path d="M18 12a2 2 0 0 0 0 4h4v-4Z"/></>,
    Sparkles:     <><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3z"/></>,
    Scissors:     <><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><line x1="20" x2="8.12" y1="4" y2="15.88"/><line x1="14.47" x2="20" y1="14.48" y2="20"/><line x1="8.12" x2="12" y1="8.12" y2="12"/></>,
    ChevronDown:  <><path d="m6 9 6 6 6-6"/></>,
    ChevronUp:    <><path d="m18 15-6-6-6 6"/></>,
    Users:        <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>,
    Zap:          <><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></>,
    ChevronRight: <><path d="m9 18 6-6-6-6"/></>,
    Home:         <><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>,
    TrendingUp:   <><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></>,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      {paths[name]}
    </svg>
  );
};

/* ══ DATA ══ */

const SUB_SERVICES = [
  {
    icon: "Scissors",
    label: "Hair Styling",
    desc: "Wash, blow-dry, braiding, relaxers, natural hair care, and finishing. Whether you want a full wash-and-style or a quick blowout before an event, a JiraniPro comes to you with their own tools and products.",
    range: "KES 500 – 3,500",
    note: "per session",
    tags: ["Wash & blowout", "Braiding", "Relaxers", "Natural hair"],
  },
  {
    icon: "Sparkles",
    label: "Makeup & Beauty",
    desc: "Professional makeup application for events, weddings, photoshoots, graduations, or everyday looks. Our verified makeup artists carry their own kits and work with all skin tones.",
    range: "KES 1,500 – 8,000",
    note: "per session",
    tags: ["Bridal makeup", "Event glam", "Natural looks", "Photoshoot ready"],
  },
  {
    icon: "Star",
    label: "Nail Care",
    desc: "Manicures, pedicures, gel nails, acrylics, nail art, and nail repairs done at your home or office. Pros bring sanitised tools, a full colour range, and their own UV lamps where needed.",
    range: "KES 700 – 4,000",
    note: "per session",
    tags: ["Manicure", "Pedicure", "Gel nails", "Nail art"],
  },
  {
    icon: "Zap",
    label: "Lash & Brow Services",
    desc: "Lash extensions, lash lifts, brow shaping, threading, tinting, and lamination. All products used are skin-safe and sourced from certified suppliers. Patch tests available on request.",
    range: "KES 1,000 – 5,500",
    note: "per session",
    tags: ["Lash extensions", "Lash lift", "Brow threading", "Brow tint"],
  },
  {
    icon: "Users",
    label: "Bridal & Event Packages",
    desc: "Full-service packages for brides, bridal parties, and group events. Includes hair, makeup, nails, and lashes in a coordinated session. Packages are priced per person and booked well in advance.",
    range: "KES 5,000 – 25,000",
    note: "per package",
    tags: ["Bride prep", "Bridal party", "Group bookings", "Corporate events"],
  },
  {
    icon: "CheckCircle",
    label: "Waxing & Hair Removal",
    desc: "Full body waxing, threading, and sugaring services done at home with hygiene-grade products. Pros use disposable applicators for every client and follow strict sanitation protocols.",
    range: "KES 800 – 4,500",
    note: "per session",
    tags: ["Full body wax", "Facial threading", "Bikini wax", "Sugaring"],
  },
];

const HOW_IT_WORKS = [
  {
    n: "01",
    icon: "Search",
    title: "Search for a Hair and Beauty Pro",
    desc: "Enter the service you need and your location. JiraniApp shows you verified Hair and Beauty professionals near you with real client reviews, their full service menu, and availability. Filter by specific service type, price range, or rating to narrow it down quickly.",
    detail: "You can search as specifically as 'lash extensions Kilimani' or as broadly as 'makeup artist Nairobi'. The results surface only professionals who have listed that exact service and are currently available in your area.",
  },
  {
    n: "02",
    icon: "BadgeCheck",
    title: "Review their profile and book",
    desc: "Every JiraniPro has a full profile showing their services, price list, portfolio photos, verified client reviews, and response rate. You can message them before booking to confirm they carry specific products or have experience with your hair type. Once you are ready, pick your date and time and confirm the booking.",
    detail: "Profiles show exactly what a Pro offers and at what price. There are no surprise charges. What you see at booking is what you pay. You can also see how many completed jobs they have and their average rating from real clients.",
  },
  {
    n: "03",
    icon: "Home",
    title: "They come to you",
    desc: "Your JiraniPro arrives at your home, office, or chosen location at the agreed time with everything they need for the service. You do not need to provide anything unless you have a preference for specific products. The Pro brings sanitised tools, their own kit, and any consumables needed for the session.",
    detail: "You can add access instructions and any preferences when you book, such as whether you have pets, parking details, or specific product sensitivities. Pros read all notes before arriving.",
  },
  {
    n: "04",
    icon: "Star",
    title: "Pay securely and leave a review",
    desc: "Pay through JiraniApp via M-Pesa once the session is complete and you are happy with the result. Your payment is held securely during the session and released to the Pro only after you confirm completion. Afterwards, leave an honest rating and review to help other clients choose well.",
    detail: "If anything is not right, raise it within 48 hours through Help and Support. Our Trust and Safety team reviews every dispute and works toward a fair resolution, including partial refunds where the service was not delivered as agreed.",
  },
];

const TRUST_POINTS = [
  {
    icon: "BadgeCheck",
    title: "Every Pro is ID-verified",
    desc: "Before any Hair and Beauty professional appears on JiraniApp, they go through identity verification. We confirm they are who they say they are. Professionals with specific certifications such as cosmetology qualifications can upload those too, and they are displayed on their profile.",
  },
  {
    icon: "Star",
    title: "Reviews from real, completed bookings only",
    desc: "You cannot leave a review on JiraniApp without having completed and paid for a booking. No anonymous ratings, no unverified feedback. Every review you read was left by a real client who had the service done. This makes ratings on our platform meaningfully more reliable than those on general listing sites.",
  },
  {
    icon: "ShieldCheck",
    title: "Backed by the Jirani Guarantee",
    desc: "If your Pro does not show up, cancels last minute, or the service is significantly different from what was agreed, you are protected. Raise a dispute within 48 hours and our team reviews both sides. Refunds are issued where the service was not delivered as described.",
  },
  {
    icon: "Wallet",
    title: "Payment only releases on your confirmation",
    desc: "When you pay through JiraniApp, your money is held securely and only sent to the Pro after you confirm the job is done. You are never in a position where you have paid upfront and have no recourse. This protects you throughout every booking.",
  },
];

const TESTIMONIALS = [
  {
    name: "Amira S.",
    area: "Kilimani, Nairobi",
    service: "Bridal makeup",
    rating: 5,
    text: "I booked a makeup artist for my wedding through JiraniApp three weeks before the date. She arrived early, had a full kit, did a trial run the week before, and on the day she was absolutely calm and professional. I have recommended her to four friends already and they all booked her. The whole experience was seamless from start to finish.",
  },
  {
    name: "Wanjiku M.",
    area: "Westlands, Nairobi",
    service: "Natural hair braiding",
    rating: 5,
    text: "Finding someone who really understands natural hair used to be a whole project. Through JiraniApp I found a braider who listed exactly the styles I was looking for, had portfolio photos on her profile, and her reviews mentioned how gentle she is with fine hair. She came to my apartment on a Sunday morning and I did not have to go anywhere. I have been rebooking her every six weeks.",
  },
  {
    name: "Fatuma A.",
    area: "Nyali, Mombasa",
    service: "Gel nails and pedicure",
    rating: 5,
    text: "I was not sure about having someone come to my home but the verified badge and the reviews gave me confidence. The nail technician was clean, professional, brought her own UV lamp, and did not rush at all. My nails looked better than anything I have had done in a salon. I am now a regular and I book her every three weeks.",
  },
];

const FAQS = [
  {
    q: "Do Hair and Beauty Pros bring their own products and tools?",
    a: "Yes. Every JiraniPro in the Hair and Beauty category arrives fully equipped for the service they have been booked for. This includes their own styling tools, sanitised nail equipment, makeup kits, waxing products, and any consumables needed. You do not need to provide anything. If you have a preference for specific products or brands, you can mention this when booking and the Pro will confirm whether they carry them or whether you need to have them available.",
  },
  {
    q: "How do I know the products used are safe for my skin or hair type?",
    a: "You can message a Pro before booking to ask about the specific products they use, their experience with your hair type or skin tone, and whether they can accommodate sensitivities or allergies. For lash and wax services, Pros are required to offer a patch test on request. If you have a known skin condition or sensitivity, disclose it when booking so the Pro can confirm they are the right fit before you commit.",
  },
  {
    q: "Can I book a Hair and Beauty Pro for an event with a group?",
    a: "Yes. Several Pros on JiraniApp offer group and event packages covering the bridal party, a corporate event, or a group of friends getting ready together. These are listed as separate package options on their profiles. For large groups, reach out to the Pro through the platform before booking to confirm they can accommodate your numbers and to agree on timing. Group bookings typically need to be made at least a week in advance.",
  },
  {
    q: "What if the Pro is late or does not show up?",
    a: "If your Pro is running late, you will be notified through the app and can message them directly. If they cancel last minute or do not arrive at all, you will not be charged. You can rebook with another available Pro immediately. Repeat cancellations by a Pro are flagged on their account and reviewed by our team. Your time matters and we take no-shows seriously.",
  },
  {
    q: "Can I rebook the same Pro every time?",
    a: "Yes, and many clients do exactly this. Once you have had a good experience with a Pro, you can go directly to their profile and book them again. Some Pros also set up recurring availability slots for regular clients, which you can ask them about through the in-app messaging. Regular clients tend to get more consistent results because the Pro already knows your preferences.",
  },
  {
    q: "What if I am not happy with the result?",
    a: "Raise a dispute through Help and Support within 48 hours of the completed booking. Describe what the issue was and attach photos if relevant. Our Trust and Safety team will review both sides and work toward a fair resolution. For Hair and Beauty specifically, we understand that results can be subjective, so we look at whether the service delivered matched what was listed and agreed in the booking, and whether the Pro followed the notes and instructions you provided.",
  },
  {
    q: "Is there a minimum booking notice required?",
    a: "This varies by Pro. Some professionals offer same-day bookings if they have availability, while others, particularly those offering bridal or event packages, prefer at least a week's notice. You can see a Pro's available slots in real time on their profile. For events and group bookings, we recommend booking as early as possible since the best-reviewed Pros fill up quickly on weekends and around major holidays.",
  },
  {
    q: "Are the Pros trained professionals or just enthusiasts?",
    a: "JiraniApp does not restrict Hair and Beauty listings to formally certified professionals only, but we do verify identity for all Pros and our review system is tied to real completed bookings. Many Pros on the platform hold cosmetology diplomas, beauty school certificates, or have trained under established salons. Where certifications exist, Pros can upload them to their profile and they will be displayed. You can use the reviews and portfolio photos to judge quality independently before booking.",
  },
];

/* ── Sub-components ── */

function StarRating({ count = 5 }) {
  return (
    <div style={{ display: "flex", gap: 2 }}>
      {Array.from({ length: count }).map((_, i) => (
        <Icon key={i} name="Star" size={13} color={T.amber} strokeWidth={0} />
      ))}
    </div>
  );
}

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom: `1px solid ${T.n100}` }}>
      <button onClick={() => setOpen(o => !o)} style={{
        width: "100%", textAlign: "left", background: "none", border: "none",
        padding: "22px 0", display: "flex", justifyContent: "space-between",
        alignItems: "center", cursor: "pointer", gap: 20, fontFamily: T.sans,
      }}>
        <span style={{ fontSize: 15, fontWeight: 400, color: T.n800, lineHeight: 1.5, letterSpacing: "-0.01em" }}>{q}</span>
        <span style={{
          width: 28, height: 28, borderRadius: "50%", flexShrink: 0,
          border: `1px solid ${open ? T.g500 : T.n200}`,
          background: open ? T.g500 : "transparent",
          color: open ? T.white : T.n400,
          display: "flex", alignItems: "center", justifyContent: "center",
          transition: "all .22s cubic-bezier(.4,0,.2,1)",
          transform: open ? "rotate(45deg)" : "none",
          fontSize: 18, fontWeight: 300, lineHeight: 1,
        }}>+</span>
      </button>
      <div style={{ overflow: "hidden", maxHeight: open ? 400 : 0, transition: "max-height .32s cubic-bezier(.4,0,.2,1)" }}>
        <p style={{ margin: "0 0 22px", fontSize: 15, color: T.n600, lineHeight: 1.8, paddingRight: 48, fontFamily: T.sans }}>{a}</p>
      </div>
    </div>
  );
}

function ServiceCard({ icon, label, desc, range, note, tags }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: "22px", borderRadius: 16,
        border: `1.5px solid ${hovered ? T.g200 : T.n150}`,
        background: hovered ? T.g50 : T.white,
        transition: "all .18s", display: "flex", flexDirection: "column", gap: 12,
      }}>
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}>
        <div style={{
          width: 40, height: 40, borderRadius: 11, flexShrink: 0,
          background: hovered ? T.g100 : T.n50,
          border: `1px solid ${hovered ? T.g200 : T.n150}`,
          display: "flex", alignItems: "center", justifyContent: "center",
          transition: "all .18s",
        }}>
          <Icon name={icon} size={17} color={hovered ? T.g600 : T.n400} strokeWidth={1.7} />
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontFamily: T.serif, fontSize: 17, fontWeight: 400, color: hovered ? T.g700 : T.n900, letterSpacing: "-0.02em", lineHeight: 1.1 }}>{range}</div>
          <div style={{ fontSize: 11, color: T.n400, marginTop: 2 }}>{note}</div>
        </div>
      </div>
      <div>
        <div style={{ fontSize: 14, fontWeight: 600, color: T.n900, marginBottom: 6, letterSpacing: "-0.01em" }}>{label}</div>
        <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.7, margin: 0 }}>{desc}</p>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 4 }}>
        {tags.map((tag, i) => (
          <span key={i} style={{
            fontSize: 11, color: hovered ? T.g700 : T.n500 || T.n600,
            background: hovered ? T.g100 : T.n50,
            border: `1px solid ${hovered ? T.g200 : T.n150}`,
            borderRadius: 99, padding: "3px 10px", fontWeight: 500,
            transition: "all .18s",
          }}>{tag}</span>
        ))}
      </div>
    </div>
  );
}

function StepCard({ step, isLast }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ display: "flex", gap: 20, position: "relative" }}>
      {!isLast && (
        <div style={{
          position: "absolute", left: 23, top: 52, bottom: open ? -8 : -20,
          width: 1, background: `linear-gradient(to bottom, ${T.g200}, ${T.n100})`,
          transition: "bottom .3s",
        }} />
      )}
      <div style={{
        width: 48, height: 48, borderRadius: 14, flexShrink: 0, zIndex: 1,
        background: T.g50, border: `1.5px solid ${T.g100}`,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <Icon name={step.icon} size={20} color={T.g500} strokeWidth={1.6} />
      </div>
      <div style={{ flex: 1, paddingBottom: isLast ? 0 : 40 }}>
        <button onClick={() => setOpen(o => !o)} style={{
          width: "100%", background: "none", border: "none", cursor: "pointer",
          padding: 0, textAlign: "left", fontFamily: T.sans,
          display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12,
        }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: T.g500, letterSpacing: "0.1em", marginBottom: 5 }}>STEP {step.n}</div>
            <div style={{ fontFamily: T.serif, fontSize: "clamp(17px,2.5vw,21px)", fontWeight: 400, color: T.n900, letterSpacing: "-0.02em", lineHeight: 1.25 }}>{step.title}</div>
          </div>
          <span style={{
            width: 26, height: 26, borderRadius: "50%", flexShrink: 0, marginTop: 16,
            border: `1px solid ${open ? T.g500 : T.n200}`,
            background: open ? T.g500 : "transparent",
            color: open ? T.white : T.n400,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 16, fontWeight: 300, lineHeight: 1,
            transition: "all .2s", transform: open ? "rotate(45deg)" : "none",
          }}>+</span>
        </button>
        <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.8, margin: "10px 0 0" }}>{step.desc}</p>
        <div style={{ overflow: "hidden", maxHeight: open ? 160 : 0, transition: "max-height .3s cubic-bezier(.4,0,.2,1)" }}>
          <div style={{ marginTop: 14, padding: "14px 16px", background: T.g50, borderRadius: 10, border: `1px solid ${T.g100}` }}>
            <p style={{ fontSize: 13, color: T.g700, lineHeight: 1.75, margin: 0 }}>{step.detail}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function Testimonial({ name, area, service, rating, text }) {
  const initials = name.split(" ").map(w => w[0]).slice(0, 2).join("");
  const palette = [
    { bg: T.g50, text: T.g700, border: T.g100 },
    { bg: "#eff6ff", text: "#1d4ed8", border: "#bfdbfe" },
    { bg: "#fdf4ff", text: "#7e22ce", border: "#e9d5ff" },
  ];
  const c = palette[name.charCodeAt(0) % palette.length];
  return (
    <div style={{ padding: "24px", borderRadius: 16, border: `1px solid ${T.n150}`, background: T.white, display: "flex", flexDirection: "column", gap: 16 }}>
      <StarRating count={rating} />
      <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.85, margin: 0, fontStyle: "italic" }}>"{text}"</p>
      <div style={{ borderTop: `1px solid ${T.n100}`, paddingTop: 16, display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ width: 38, height: 38, borderRadius: "50%", background: c.bg, border: `1.5px solid ${c.border}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 600, color: c.text, flexShrink: 0 }}>{initials}</div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 600, color: T.n900 }}>{name}</div>
          <div style={{ fontSize: 12, color: T.n400 }}>{service} · {area}</div>
        </div>
      </div>
    </div>
  );
}

/* ══ MAIN PAGE ══ */
export default function HairBeautyPage() {
  useFonts();
  const navigate = useNavigate();
  const [location, setLocation] = useState("");
  const [locationFocused, setLocationFocused] = useState(false);

  const handleSearch = () => {
    const params = new URLSearchParams({ category: "hair-beauty" });
    if (location.trim()) params.set("location", location.trim());
    navigate(`/search?${params.toString()}`);
  };

  return (
    <div style={{ fontFamily: T.sans, background: T.white, minHeight: "100vh", color: T.n900, paddingBottom: 80 }}>
      <style>{`
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { display: none; }
      `}</style>

      {/* ── Nav ── */}
      <div style={{ padding: "16px 24px", borderBottom: `1px solid ${T.n100}`, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <button onClick={() => navigate(-1)} style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "none", border: "none", cursor: "pointer",
          color: T.n400, fontSize: 13, fontFamily: T.sans, padding: 0,
        }}
          onMouseEnter={e => e.currentTarget.style.color = T.n800}
          onMouseLeave={e => e.currentTarget.style.color = T.n400}>
          <Icon name="ArrowLeft" size={14} strokeWidth={2} />
          Back
        </button>
        <button onClick={() => navigate("/become-a-pro")} style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "none", border: `1px solid ${T.n200}`,
          cursor: "pointer", color: T.n600, fontSize: 13,
          fontFamily: T.sans, padding: "8px 16px", borderRadius: 8, fontWeight: 500,
        }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = T.g400; e.currentTarget.style.color = T.g600; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = T.n200; e.currentTarget.style.color = T.n600; }}>
          <Icon name="Scissors" size={13} strokeWidth={2} />
          Are you a Hair and Beauty Pro? Join free
        </button>
      </div>

      {/* ══ HERO ══ */}
      <div style={{ padding: "clamp(52px,7vw,88px) 20px clamp(44px,5vw,64px)", borderBottom: `1px solid ${T.n100}`, background: `linear-gradient(160deg, ${T.g50} 0%, ${T.white} 60%)` }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, color: T.g600, fontSize: 12, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 22 }}>
            <Icon name="Sparkles" size={14} color={T.g500} strokeWidth={2.2} />
            Hair and Beauty
          </div>
          <h1 style={{ fontFamily: T.serif, fontSize: "clamp(38px,7vw,68px)", fontWeight: 400, margin: "0 0 18px", lineHeight: 1.06, color: T.n900, letterSpacing: "-0.03em", maxWidth: 620 }}>
            Professional beauty services,<br />
            <em style={{ fontStyle: "italic", color: T.g600 }}>at your door</em>
          </h1>
          <p style={{ fontSize: "clamp(15px,2vw,17px)", color: T.n600, lineHeight: 1.8, margin: "0 0 36px", maxWidth: 500 }}>
            Book verified hair stylists, makeup artists, nail technicians, lash specialists, and more. They come to you, fully equipped, at a time that works for you.
          </p>

          {/* Search bar */}
          <div style={{ display: "flex", gap: 10, maxWidth: 520, flexWrap: "wrap" }}>
            <div style={{ position: "relative", flex: 1, minWidth: 200 }}>
              <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
                <Icon name="MapPin" size={16} color={T.n400} strokeWidth={1.8} />
              </span>
              <input
                value={location}
                onChange={e => setLocation(e.target.value)}
                onFocus={() => setLocationFocused(true)}
                onBlur={() => setLocationFocused(false)}
                onKeyDown={e => e.key === "Enter" && handleSearch()}
                placeholder="Your estate or area..."
                style={{
                  width: "100%", padding: "15px 16px 15px 42px",
                  border: `1px solid ${locationFocused ? T.g500 : T.n200}`,
                  borderRadius: 11, fontSize: 14, outline: "none",
                  background: T.white, color: T.n900, fontFamily: T.sans,
                  boxShadow: locationFocused ? `0 0 0 4px ${T.g100}` : "0 1px 4px rgba(0,0,0,.06)",
                  transition: "all .18s",
                }} />
            </div>
            <button onClick={handleSearch} style={{
              padding: "15px 28px", background: T.g500, color: T.white,
              border: "none", borderRadius: 11, fontSize: 14, fontWeight: 600,
              cursor: "pointer", fontFamily: T.sans,
              display: "inline-flex", alignItems: "center", gap: 8,
              whiteSpace: "nowrap",
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              <Icon name="Search" size={15} color={T.white} strokeWidth={2} />
              Find a Pro
            </button>
          </div>

          <p style={{ fontSize: 12, color: T.n400, margin: "12px 0 0" }}>
            Available in Nairobi, Mombasa, Kisumu, Nakuru and Eldoret
          </p>
        </div>
      </div>

      {/* ══ TRUST STRIP ══ */}
      <div style={{ borderBottom: `1px solid ${T.n100}`, padding: "0 20px" }}>
        <div style={{ maxWidth: 720, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))" }}>
          {[
            { icon: "BadgeCheck", label: "Every Pro is ID-verified before going live" },
            { icon: "Star",       label: "Reviews tied to real, completed bookings only" },
            { icon: "ShieldCheck", label: "Jirani Guarantee backs every session" },
          ].map(({ icon, label }, i) => (
            <div key={i} style={{ padding: "20px", display: "flex", alignItems: "center", gap: 11, borderRight: i < 2 ? `1px solid ${T.n100}` : "none" }}>
              <Icon name={icon} size={17} color={T.g500} strokeWidth={1.5} />
              <span style={{ fontSize: 13, color: T.n600, lineHeight: 1.4 }}>{label}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 20px" }}>

        {/* ══ SUB-SERVICES ══ */}
        <div style={{ paddingTop: "clamp(48px,7vw,72px)", marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Services available</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Everything hair and beauty,<br />
            <em style={{ fontStyle: "italic", color: T.g600 }}>at your location</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 28px", lineHeight: 1.65 }}>
            Browse the full range of Hair and Beauty services available on JiraniApp. Each Pro lists the specific services they offer and their prices, so you always know exactly what you are booking and what you will pay.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 14 }}>
            {SUB_SERVICES.map((s, i) => <ServiceCard key={i} {...s} />)}
          </div>
        </div>

        {/* ══ HOW IT WORKS ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>How it works</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            From search to session in <em style={{ fontStyle: "italic", color: T.g600 }}>four steps</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 32px", lineHeight: 1.65 }}>
            Tap any step to see what actually happens at that stage. No surprises, no hidden steps.
          </p>
          <div style={{ paddingLeft: 4 }}>
            {HOW_IT_WORKS.map((step, i) => (
              <StepCard key={i} step={step} isLast={i === HOW_IT_WORKS.length - 1} />
            ))}
          </div>
        </div>

        {/* ══ TRUST SECTION ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)", padding: "clamp(28px,5vw,44px)", borderRadius: 20, background: T.g50, border: `1px solid ${T.g100}` }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Your protection</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(24px,4vw,34px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
            Every booking is <em style={{ fontStyle: "italic", color: T.g600 }}>backed by us</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n600, lineHeight: 1.75, margin: "0 0 28px" }}>
            Letting someone into your home requires trust. Here is exactly how JiraniApp earns and maintains it on every Hair and Beauty booking.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 20 }}>
            {TRUST_POINTS.map((pt, i) => (
              <div key={i} style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
                <div style={{ width: 38, height: 38, borderRadius: 10, background: T.white, border: `1px solid ${T.g100}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <Icon name={pt.icon} size={16} color={T.g500} strokeWidth={1.7} />
                </div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: T.n900, marginBottom: 6, letterSpacing: "-0.01em" }}>{pt.title}</div>
                  <p style={{ fontSize: 13, color: T.g700, lineHeight: 1.75, margin: 0 }}>{pt.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ══ TESTIMONIALS ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Client stories</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            What clients say after their <em style={{ fontStyle: "italic", color: T.g600 }}>first booking</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 24px", lineHeight: 1.65 }}>
            Every review below is from a verified booking on JiraniApp. No editorial. No incentivised reviews.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(290px, 1fr))", gap: 14 }}>
            {TESTIMONIALS.map((t, i) => <Testimonial key={i} {...t} />)}
          </div>
        </div>

        {/* ══ FAQ ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Common questions</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 4px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Before you <em style={{ fontStyle: "italic", color: T.g600 }}>book</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 8px", lineHeight: 1.65 }}>
            Everything clients ask us most often about Hair and Beauty bookings.
          </p>
          <div style={{ marginTop: 8 }}>
            {FAQS.map((item, i) => <FaqItem key={i} {...item} />)}
          </div>
        </div>

        {/* ══ FOOTER CTA ══ */}
        <div style={{ padding: "clamp(36px,5vw,56px)", borderRadius: 20, border: `1px solid ${T.n150}`, textAlign: "center", background: T.n50, marginBottom: 20 }}>
          <div style={{ width: 52, height: 52, borderRadius: 14, background: T.g50, border: `1.5px solid ${T.g200}`, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
            <Icon name="Sparkles" size={22} color={T.g500} strokeWidth={1.6} />
          </div>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,38px)", fontWeight: 400, color: T.n900, margin: "0 0 12px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Ready to book your<br />
            <em style={{ fontStyle: "italic", color: T.g600 }}>Hair and Beauty Pro?</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 auto 32px", lineHeight: 1.75, maxWidth: 400 }}>
            Find a verified professional near you, check their portfolio and reviews, and book a time that works. They come to you.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={handleSearch} style={{
              padding: "14px 32px", background: T.g500, color: T.white,
              border: "none", borderRadius: 11, fontSize: 15, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
              display: "inline-flex", alignItems: "center", gap: 8,
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              Find a Hair and Beauty Pro
              <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
            </button>
            <button onClick={() => navigate("/how-it-works")} style={{
              padding: "14px 28px", background: "transparent", color: T.n700,
              border: `1.5px solid ${T.n200}`, borderRadius: 11, fontSize: 15, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
            }}
              onMouseEnter={e => e.currentTarget.style.borderColor = T.n400}
              onMouseLeave={e => e.currentTarget.style.borderColor = T.n200}>
              How JiraniApp works
            </button>
          </div>
          <p style={{ fontSize: 12, color: T.n300, margin: "20px 0 0" }}>
            Free to browse · No booking fees · Pay only when you confirm
          </p>
        </div>

      </div>
    </div>
  );
}